define(['jquery', 'c21/track'], function ($, track) {
   "use strict";

   return function () {
      var m_iMaxDisplayThumbnails,
         m_iNumThumbnails,
         m_iCurrentImage,
         m_iCurrentPage,
         m_jLargeImagePreview,
         m_jViewFullScreen,
         m_loadingImage,
         m_oThumbnailByPosition = {},
         m_iDefaultImage;

      function getPageByPosition (iPosition) {
         var iPage = Math.floor(iPosition / m_iMaxDisplayThumbnails);
         return iPage;
      }

      function setImage (strImage) {
         $("#largeImagePreview").removeClass("loading");
         m_jLargeImagePreview.find('img').attr('src', strImage);
         $("#viewImageFullScreen .viewImageFullScreenBg").css({
            backgroundImage: "url(" + strImage + ")"
         });
      }

      function setSelectedThumb (iThumb) {
         let photo = window.photos[iThumb];
         let jImageContainer = $('.propImageLarge');

         if (photo && photo.matterportId) {
            jImageContainer.find('img, #viewImageFullScreen').hide();
            jImageContainer.find('.matterport-container').show();
         } else {
            jImageContainer.find('.matterport-container').hide();
            jImageContainer.find('img, #viewImageFullScreen').show();

            let strImage = photo && photo.imageUrl ? photo.imageUrl : '/images/eco/icons/nopropertyfound.png';

            $("#largeImagePreview").addClass("loading");

            if (m_loadingImage) {
               m_loadingImage.onload = null;
            }

            m_loadingImage = new Image();
            m_loadingImage.onload = function () {
               setImage(strImage);
            };
            m_loadingImage.onerror = function () {
               setImage("/images/eco/icons/nopropertyfound.png");
            };
            m_loadingImage.src = strImage;
         }

         m_iCurrentImage = iThumb;
         $(".selectedThumbnail").removeClass("selectedThumbnail");
         if (photo) {
            m_oThumbnailByPosition[iThumb].parent().addClass("selectedThumbnail");
            $("#photoCaption").text(photo.caption);
         }

         let iPage = getPageByPosition(iThumb);
         if (iPage !== m_iCurrentPage) {
            setPage(iPage);
         }

         if (iThumb === 0) {
            $("#previousPhotoButton").hide();
         } else {
            $("#previousPhotoButton").show();
         }

         if (iThumb === (m_iNumThumbnails - 1)) {
            $("#nextPhotoButton").hide();
         } else {
            $("#nextPhotoButton").show();
         }

         $(".pageButtons .pageText").html( (iThumb + 1) + " of " + m_iNumThumbnails);
      }

      function onLargeImageClick() {
         if(!m_jViewFullScreen.is(":visible")) {
            return;
         }
         track.doEvent('PDP', 'Realbiz Full Screen', 'Viewer Opened');
      }

      function onLargeImageMouseEnter() {
         /*jshint validthis:true */
         track.doEvent('PDP', 'Realbiz Full Screen', 'Image Rollover Info');
         this.iLargeImageHoverTimeout = setTimeout(function() {
            m_jViewFullScreen.slideDown(300);
         }, 300);
      }

      function onLargeImageMouseLeave() {
         /*jshint validthis:true */
         if (this.iLargeImageHoverTimeout) {
            clearTimeout(this.iLargeImageHoverTimeout);
         }
         m_jViewFullScreen.slideUp(150);
      }

      /**
       * Check if the Realbiz FSV Dynamic JS is available
       *
       */
      function isRealbizDynamicFSVEnabled() {
         // Disable FSV in IE8 and IE9
         if(navigator.appVersion.indexOf("MSIE 8.") !== -1 || navigator.appVersion.indexOf("MSIE 9.") !== -1) {
            return false;
         }

         if (typeof(window.startslideshow) === "function") {
            return true;
         }
         return false;
      }

      function enableFullScreenViewer() {
         $("#largeImageContainer")
            .click(onLargeImageClick)
            .hover(onLargeImageMouseEnter, onLargeImageMouseLeave);

         $("#Gallery").css("cursor", "pointer");

         // Call this function which is in the Realbiz dynamic guid JS
         if (typeof(window.addElement) === "function") {
            window.addElement();
         }

         if (window.Modernizr.touch) {
            $(".img")
               .addClass("hover")
               .click(function(e) {
                  if (typeof(window.startslideshow) === "function") {
                     window.startslideshow();
                  }
               });

            $(".close-overlay").click(function(e) {
               e.preventDefault();
               e.stopPropagation();
               if ($(this).closest(".img").hasClass("hover")) {
                  $(this).closest(".img").removeClass("hover");
               }
            });
         } else {
            $(".img").mouseenter(function() {
               $(this).addClass("hover");
            }).mouseleave(function() {
               $(this).removeClass("hover");
            }).click(function() {
               $(this).addClass("hover");
               window.startslideshow();
            });
         }
      }

      /**
       * Force the animation to complete
       * @param jElem
       */
      function triggerReflow (jElem) {
         var el = jElem.get(0),
            iOffset = el.offsetWidth;

         // Simply querying the property will cause the browser to reflow.
         // See: http://mir.aculo.us/2010/08/17/when-does-javascript-trigger-reflows-and-rendering/
         // NOTE: We can not SET the property, as it is read-only
         if (el.offsetWidth > iOffset) { /* ... */ }
      }

      function setPage (iPage) {
         var bMovingForward = false,
            bMovingBackward = false,
            jMovingTo;

         if (iPage === m_iCurrentPage) {
            return;
         } else if (iPage > m_iCurrentPage) {
            bMovingForward = true;
         } else {
            bMovingBackward = true;
         }

         var jPrevious = $(".pageShow");
         jPrevious.removeClass("pageShow pageBehindLeft pageBehindRight").addClass("anim");

         if (bMovingForward) {
            jPrevious.addClass("pageBehindRight");
         } else {
            jPrevious.addClass("pageBehindLeft");
         }

         m_iCurrentPage = iPage;
         setPhotoPageLinks();
         jMovingTo = $(".thumbPage").eq(iPage);
         jMovingTo.removeClass("pageBehindRight pageBehindLeft").addClass("anim");

         if (bMovingForward) {
            jMovingTo.addClass("pageNext");
         } else {
            jMovingTo.addClass("pagePrevious");
         }

         triggerReflow(jMovingTo);

         jMovingTo.removeClass("pageNext pagePrevious").addClass("pageShow");
      }

      function onRangeClick () {
         /*jshint validthis:true */
         var jThis = $(this),
            iPosition = jThis.attr("rel"),
            iPage = getPageByPosition(iPosition);

         setPage(iPage);
      }

      /**
       *  Set the photo page numbers next and previous button links and text.
       */
      function setPhotoPageLinks() {
         let jLinks = $("#photoPageLinks"),
             jPageText = $("#photoPageLinks .pageText"),
             jPrevPageBtn = $("#photoPageLinks #prevPhotoPageBtn"),
             jNextPageBtn = $("#photoPageLinks #nextPhotoPageBtn"),
             iTotalPages = Math.ceil(m_iNumThumbnails/m_iMaxDisplayThumbnails);
         jPrevPageBtn.hide();
         jNextPageBtn.hide();
         if((m_iCurrentPage + 1) < iTotalPages) {
            jNextPageBtn.show();
         }
         if(m_iCurrentPage > 0 && m_iCurrentPage <= iTotalPages) {
            jPrevPageBtn.show();
         }
         jPageText.html( "Page " + (m_iCurrentPage + 1) + " of " + iTotalPages);
      }

      /**
       *  Initialize photo page actions (next and previous page button click events).
       */
      function initPhotoPageLinkActions() {
         let jPrevPageBtn = $("#photoPageLinks #prevPhotoPageBtn"),
             jNextPageBtn = $("#photoPageLinks #nextPhotoPageBtn");
         $(jPrevPageBtn).click(function () {
            setPage(m_iCurrentPage - 1);
         });
         $(jNextPageBtn).click(function () {
            setPage(m_iCurrentPage + 1);
         });
      }

      function processThumbnail (i, jRow, jPage, jPhotoPageContainer, thumbnail) {
         let bNewRow = ((i % 2) === 0);
         let bNewPage = ((i % m_iMaxDisplayThumbnails) === 0);

         // Create a new page if necessary
         if (bNewPage) {
            jPage = $('<div class="thumbPage anim"></div>');
            jPhotoPageContainer.append(jPage);

            if (i === 0) {
               jPage.addClass("pageShow");
            } else {
               jPage.addClass("pageBehindLeft");
            }
         }

         // Create a new row if necessary
         if (bNewRow) {
            jRow = $('<div class="thumbRow row"></div>');
            jPage.append(jRow);
         }

         // Create column to hold the thumbnail container
         let jCol = $('<div class="col-sm-6 thumbColumn"></div>');
         jRow.append(jCol);

         // Create container to hold the thumbnail
         let jImgContainer = $('<div class="propertyThumbnailContainer"></div>');
         jCol.append(jImgContainer);

         // The majestic thumbnail itself
         let jThumb = $('<img class="propertyThumbnail" />')
            .attr({
               src: thumbnail.thumbUrl,
               alt: thumbnail.caption
            });
         jImgContainer.append(jThumb);
         m_oThumbnailByPosition[i] = jThumb;

         if (thumbnail.matterportId) {
            jThumb.attr({
               role: 'presentation',
               alt: ""

            });
            // Matterport has a little play icon over the image
            let jMatterportIcon = $('<span class="matterport-icon"></span>');

            jImgContainer
               .addClass('showcaseThumbnailContainer')
               .append(jMatterportIcon);
         }

         jImgContainer.click(() => {
            track.doEvent('PDP', 'Click Photo');
            setSelectedThumb(i);
         });

         return [jRow, jPage, jPhotoPageContainer];
      }

      function generateThumbnailElements (defaultImg) {
         var jPhotoPageContainer = $("#photoPageContainer"),
            jPropertyDetails = $("#propertyDetails");

         if (jPropertyDetails.data('show3dshowcase') === true && jPropertyDetails.data('matterportid')) {
            window.photos.unshift({
               matterportId: jPropertyDetails.data('matterportid'),
               thumbUrl: window.photos[defaultImg].thumbUrl
            });
         }

         let jRow, jPage;
         window.photos.forEach((thumb, i) => {
            [jRow, jPage, jPhotoPageContainer] = processThumbnail(i, jRow, jPage, jPhotoPageContainer, thumb);
         });
      }

      function calculateHeight () {
         var jFirstRow = $(".thumbPage.pageShow .row:first"),
            iThumbHeight = jFirstRow.height(),
            iThumbOuterHeight = jFirstRow.outerHeight(),
            iThumbsTotalHeight = (iThumbOuterHeight * 2) + iThumbHeight,
            jImagePreview = $("#largeImagePreview"),
            jThumbContainer = $("#photoPageContainer"),
            iPreviewHeight = jImagePreview.height(),
            iThumbMarginTop,
            iPreviewMarginTop;

         jThumbContainer.css('min-height', iThumbsTotalHeight);

         if (iPreviewHeight < iThumbsTotalHeight) {
            iThumbMarginTop = 0;
            iPreviewMarginTop = Math.ceil((iThumbsTotalHeight - iPreviewHeight) / 2);
         } else {
            iThumbMarginTop = (iPreviewHeight - iThumbsTotalHeight) / 2;
            iPreviewMarginTop = 0;
         }

         jThumbContainer.css('margin-top', iThumbMarginTop);
         jImagePreview.css('padding-top', iPreviewMarginTop);
         jImagePreview.css('padding-bottom', iPreviewMarginTop);
      }

      return {
         initialize : function() {
            m_iCurrentImage = 0;
            m_iCurrentPage = 0;
            m_iMaxDisplayThumbnails = 6;
            m_jLargeImagePreview = $('#largeImagePreview');

            // Default image to display on page load
            m_iDefaultImage = parseInt($("#propertyPhotoTab").data("defaultimage"));

            generateThumbnailElements(m_iDefaultImage);

            m_iNumThumbnails = window.photos.length;

            // Handle Realbiz full screen viewer
            m_jViewFullScreen = $("#viewImageFullScreen");
            var showImageFSV = $("#showImageFSV").val();
            var jRealbizFSVJS = $("#realbizFSVJS");
            if (showImageFSV !== null && showImageFSV === "true" && m_jViewFullScreen.length > 0 && jRealbizFSVJS.length > 0) {
               // http://devel.afigliolia.cyberitas.com/jstest.php
               $.getScript(jRealbizFSVJS.val(), function() { // Load the Realbiz JS first before enabling FSV
                  if (isRealbizDynamicFSVEnabled()) {
                     enableFullScreenViewer();
                  }
               });
            }

            m_jLargeImagePreview.find("img").on("load", calculateHeight);
            setSelectedThumb(m_iDefaultImage);
            $(window).resize(calculateHeight);
            calculateHeight();

            if (m_iNumThumbnails > 1) {
               $('#previousPhotoButton').click(function () {
                  if ($(this).hasClass("disabled")) return;
                  var iPosition = (m_iCurrentImage - 1) % m_iNumThumbnails;
                  setSelectedThumb(iPosition);
               });

               $('#nextPhotoButton').click(function () {
                  if ($(this).hasClass("disabled")) return;
                  var iPosition = (m_iCurrentImage + 1) % m_iNumThumbnails;
                  setSelectedThumb(iPosition);
               });
            }

            setPhotoPageLinks();
            initPhotoPageLinkActions();
         }
      };
   };
});
